import {
  // eslint-disable-next-line no-unused-vars
    SettingsIcon,
  // eslint-disable-next-line no-unused-vars
    SlidersIcon,
  // eslint-disable-next-line no-unused-vars
    UsersIcon,
  // eslint-disable-next-line no-unused-vars
    CpuIcon,
  // eslint-disable-next-line no-unused-vars
    CommandIcon,
  // eslint-disable-next-line no-unused-vars
    LayersIcon,
  // eslint-disable-next-line no-unused-vars
    FileIcon,
  // eslint-disable-next-line no-unused-vars
    GridIcon,
  // eslint-disable-next-line no-unused-vars
    PocketIcon,
  // eslint-disable-next-line no-unused-vars
    LayoutIcon,
  // eslint-disable-next-line no-unused-vars
    MessageCircleIcon
} from 'vue-feather-icons';
/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default [
  {
    url: "/",
    name: "Brokers",
    icon: "UsersIcon",
    submenu: [
      {
        url: "/brokers",
        name: "All Brokers",
        slug: "Brokers",
      },
      {
        url: "/add-broker",
        name: "Add Broker",
        slug: "add-broker",
      }
    ]
  },
  {
    url: "/brokers-promos",
    name: "Brokers Promo Codes",
    slug: "brokers-promos",
    icon: "GiftIcon",
  },
  {
    url: "/brokers-commissions",
    name: "Commissions",
    slug: "brokers-commissions",
    icon: "DollarSignIcon",
    submenu: [
      {
        url: "/brokers-commissions/commissions-view",
        name: "Commissions View",
        slug: "Brokers Commissions",
      },
      {
        url: "/brokers-commissions/brokers-view",
        name: "Brokers View",
        slug: "Brokers Commissions",
      }
    ]
  },
]

